import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import SecurityService from './security.service';
import SecurityApiService from './security.api';
import SessionService from './session.service';
import TimeoutService from './timeout.service';

import StorageService from '../storage.service';
import environment from 'environment';

let storageService = new StorageService();
let siteOrigin = storageService.getItem('site_origin') ? storageService.getItem('site_origin') : environment.ASIANCONNECT_URL;

let securityModule = angular.module('app.security', [
  uiRouter
])
.config(($stateProvider, $urlRouterProvider) => {
  'ngInject';

  $stateProvider
  .state('log-out', {
    url: '/logout',
    template: '',
    params: {
      reason: null
    },
    onEnter: function(SecurityService, $stateParams) {
      // window.location will reload the page thus destroying all subscriptions and initialized services.
      SecurityService.logout().then(() => {
        if (!siteOrigin || siteOrigin === 'undefined') {
          window.location.assign('?status=' + $stateParams.reason);
        } else {
          window.location.assign(siteOrigin + '?status=' + $stateParams.reason);
        }
      });
    }
  })
  ;
})
.service('SecurityService', SecurityService)
.service('SecurityApiService', SecurityApiService)
.service('SessionService', SessionService)
.service('TimeoutService', TimeoutService)
.service('StorageService', StorageService)
.name;

export default securityModule;



// WEBPACK FOOTER //
// ./client/app/shared/security/security.module.js